export type SegmentedControlSize = 'sm' | 'md'

/** The rail and thumb classes of a segmented rail per size; `sm` totals 24px and `md` 34px rendered height. */
export const SEGMENTED_SCALE = {
  md: {
    rail: 'rounded-6 p-2',
    thumb: 'rounded-6-in-2',
    cellRadius: 'rounded-6-in-2',
    text: 'text-body-sm',
    box: 'px-8 py-2',
    iconBox: 'px-8 py-2',
    height: 'h-lh',
  },
  sm: {
    rail: 'rounded-4 p-1',
    thumb: 'rounded-4-in-1',
    cellRadius: 'rounded-4-in-1',
    text: 'text-caption',
    box: 'px-4 py-1',
    iconBox: 'px-2 py-1',
    height: 'h-(--icon-size-sm)',
  },
} as const satisfies Record<SegmentedControlSize, Record<string, string>>

/** The sliding thumb's surface, shared by every segmented rail. */
export const SEGMENTED_THUMB =
  'absolute inset-y-0 left-0 bg-bg-content shadow-1 transition-[transform,width] duration-base ease-soft'

/** The glass face inside the thumb. */
export const SEGMENTED_THUMB_FACE = 'block size-full bg-glass-card inset-shadow-glass-edge'
